import { forwardRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import {
    Input,
    inputHeight,
    StyledInput,
    labelHeight,
    labelMarginBottom,
} from '../input'
import { BaseButton } from '../buttons/baseButton'
import AddIcon from '@tuhi/components/assets/icons/buttons/add.svg'

const Column = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0em 1em;
`

const Container = styled.div<{ $isFocus?: boolean }>`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: fit-content;
    width: 100%;

    border: ${(p) =>
        `1px solid ${
            p.$isFocus ? p.theme.colors.primaryGreen : p.theme.colors.darkGrey
        }`};

    ${StyledInput} {
        border: none;
    }
`

const Label = styled.label`
    font-size: 13px;
    color: ${(p) => p.theme.colors.mediumGrey};
    margin-bottom: ${labelMarginBottom}px;
    height: ${labelHeight}px;
`

const Icon = styled.div<{ $isFocus?: boolean }>`
    height: ${inputHeight}px;
    width: ${inputHeight}px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(p) =>
        p.$isFocus ? p.theme.colors.primaryGreen : p.theme.colors.darkGrey};
`

const AddButton = styled(BaseButton)`
    line-height: 2em;
    font-size: 1em;
    width: 30%;
    border: 1px solid ${(p) => p.theme.colors.primaryGreen};
    color: ${(p) => p.theme.colors.primaryGreen};

    &:hover {
        background: ${(p) => p.theme.colors.primaryGreen};
        color: ${(p) => p.theme.colors.white};
    }
`

interface Props {
    label?: string
    placeholder?: string
    onAdd: (text: string) => void
    onFocus?: () => void
    onBlur?: () => void
}

export const AddBox = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { label, placeholder, onAdd, onBlur, onFocus } = props
    const [isFocus, setIsFocus] = useState(false)
    const [value, setValue] = useState('')

    useEffect(() => {
        if (!isFocus) {
            if (onBlur) onBlur()
        }
    }, [isFocus])

    const handleKeyDown = (key: string) => {
        if (key === 'Enter') {
            onAdd(value)
            setValue('')
        }
    }

    return (
        <Column>
            {label && <Label>{label}</Label>}
            <Container $isFocus={isFocus}>
                <Icon $isFocus={isFocus}>
                    <span
                        style={{
                            width: '1.5em',
                            height: '1.5em',
                            display: 'inline-block',
                        }}
                    >
                        <AddIcon />
                    </span>
                </Icon>
                <Input
                    $width="100%"
                    ref={ref}
                    value={value}
                    type="text"
                    placeholder={placeholder}
                    autoFocus
                    onFocus={() => {
                        setIsFocus(true)
                        if (onFocus) onFocus()
                    }}
                    onBlur={(event) => {
                        setIsFocus(false)
                    }}
                    onChange={(event) => {
                        setValue(event.target.value)
                    }}
                    onKeyDown={(event) => {
                        handleKeyDown(event.key)
                    }}
                />
            </Container>
        </Column>
    )
})
